import { Component } from '@angular/core';

declare var jQuery:any;

@Component({
  selector: 'blank',
  template: require('./blankLayout.template.html')
})
export class BlankLayoutComponent {

  ngAfterViewInit() {
    jQuery('body').addClass('gray-bg');
  }

  ngOnDestroy() {
    jQuery('body').removeClass('gray-bg');
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/components/common/layouts/blankLayout.component.ts